import { render, staticRenderFns } from "./CalculationTable.vue?vue&type=template&id=f33fc3c8&scoped=true&"
import script from "./CalculationTable.vue?vue&type=script&lang=ts&"
export * from "./CalculationTable.vue?vue&type=script&lang=ts&"
import style0 from "./CalculationTable.vue?vue&type=style&index=0&id=f33fc3c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33fc3c8",
  null
  
)

export default component.exports